import { EndpointError } from '@square/ignition';
import { ErrorCodeExampleAsideLayout } from '@squareup/dex-tech-ui';
import React, { FunctionComponent, useState } from 'react';

import { ReferenceErrorTable } from '../../ReferenceErrorTable';

interface ReferenceErrorContainerProps {
  tableName: string;
  errors: EndpointError[] | undefined;
  selectedErrorRow: EndpointError;
}

const ReferenceErrorContainer: FunctionComponent<
  ReferenceErrorContainerProps
> = ({ tableName, errors, selectedErrorRow }) => {
  const [currentError, setCurrentError] = useState(selectedErrorRow);
  return (
    <>
      <section>
        <ReferenceErrorTable
          errors={errors}
          tableName={tableName}
          changeRow={setCurrentError}
          selectedErrorRow={currentError}
        ></ReferenceErrorTable>
      </section>
      <aside>
        <ErrorCodeExampleAsideLayout
          selectedError={currentError}
        ></ErrorCodeExampleAsideLayout>
      </aside>
    </>
  );
};

export { ReferenceErrorContainer };
